import { useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";

import TextField from "@mui/material/TextField";

import { colors } from "../variables";
import { styles } from "./styles"; // Assuming the JavaScript file is in the same directory

import ChatHistory from "./ChatHistory";

const serverUrl = process.env.REACT_APP_SERVER_URL;

function App(props) {
  const model = "text-davinci-003";
  const maxTokens = 2048;
  const temperature = 0.0;

  const [q, setQ] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const messageInput = useRef(null);

  // Set the focus to the password input
  useEffect(() => {
    messageInput.current.focus();
    messageInput.current.addEventListener("keydown", (event) => {
      event.stopPropagation();
    });
  }, []);

  useEffect(() => {
    fetchData("Let's go!", chatHistory);
  }, [props.prompt]);

  // Clears the chat history
  const clearChatHistory = () => {
    setChatHistory([]);
  };

  // Adds the message to the end of the chat history
  const addMessage = async (username, text, history) => {
    const chat = {
      id: uuidv4(),
      username,
      text,
    };
    history.push(chat);
    setChatHistory(history);
  };

  // Fetches the chat history from the server
  const fetchData = async (text, history) => {
    setLoading(true);
    addMessage("me", text, history);
    try {
      const response = await fetch(serverUrl, {
        method: "POST",
        body: JSON.stringify({
          password: props.password,
          model: model,
          max_tokens: maxTokens,
          temperature: temperature,
          chatHistory: history,
          prompt: props.prompt,
        }),
        headers: { "Content-Type": "application/json" },
      });
      const json = await response.json();
      setLoading(false);
      addMessage(json.username, json.text, history);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  return (
    <div style={styles.wrapper}>
      <br />
      <ChatHistory chatHistory={chatHistory} loading={loading} />
      <TextField
        ref={messageInput}
        InputLabelProps={{
          sx: {
            typography: {
              fontFamily: "Gilroy",
              fontSize: "1.2rem",
              top: "-.2em",
              paddingRight: ".75em",
              backgroundColor: colors.grayBackground,
            },
          },
        }}
        InputProps={{
          sx: {
            typography: { fontFamily: "Gilroy" },
          },
        }}
        autoFocus
        style={styles.Input}
        className="Input"
        label="Ask something..."
        multiline
        rows={3}
        value={q}
        onChange={(e) => {
          setQ(e.target.value);
        }}
        onKeyPress={(event) => {
          if (event.key === "Enter" && !event.shiftKey) {
            if (q.length > 0) {
              fetchData(q, chatHistory);
              setQ("");
            }
          }
        }}
      />
    </div>
  );
}

export default App;
